import * as CategoryTabsActions from './category-tabs.actions';
import * as CategoryTabsStoreSelector from './category-tabs.selectors';
import * as CategoryTabsStoreState from './category-tabs.state';

export { CategoryTabsModule } from './category-tabs.module';
export { CategoryTabsActions, CategoryTabsStoreSelector, CategoryTabsStoreState };
